import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
  height: 300px;
  border-radius: 8px;
  padding-right: 14px;
  border: ${(props: { file: string }) =>
    props.file ? null : `1px solid #8a919c`};
`;

export const Label = styled.label`
  height: 38px;
  background: rgba(241, 244, 251, 1);
  border-radius: 32px;
  display: inline-block;
  padding: 10px 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #4d9fc4;
  cursor: pointer;
  margin-right: 16px;
`;

export const Action = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const PositionLabel = styled(Label)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ImgVerticalMiddle = styled.span`
  vertical-align: top;
  margin-left: -4px;
  margin-right: 6px;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 16px;
`;
